import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
  [key: string]: any; 
}

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px', ...props}) => {
  return (
    <span className={`svg-icon  ${className}`} {...props}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export {KTSVG}
